import { useSelectSearch } from '../useSelectSearch'
import { useSelectShowSelected } from '../useSelectShowSelected'
import { useSelectStates } from '../useSelectStates'

export function useSyncSelectStates({
  blocked,
  clearSearchOnSelect,
  disabled,
  dropdownFloatingConfig,
  filter,
  initialSearchValue,
  multi,
  options,
  value,
  onChangeSearch,
  onSelectAll,
  onSelectItem,
}) {
  const { handleChangeSearch, handleClearSearch, searchValue } =
    useSelectSearch({ initialValue: initialSearchValue, onChangeSearch })

  const { handleToggleShowSelected, showSelected } = useSelectShowSelected({})

  const filteredOptions = filter
    ? options.filter(item => filter(item, searchValue))
    : options

  const {
    activeIndex,
    context,
    elementsRef,
    floatingStyles,
    getFloatingItemProps,
    getFloatingProps,
    getReferenceProps,
    handleClose,
    handleKeyDown,
    handleOpen,
    handleSelect,
    handleToggleOpen,
    isOpen,
    refs,
    setOpen,
  } = useSelectStates({
    blocked,
    clearSearchOnSelect,
    disabled,
    dropdownFloatingConfig,
    multi,
    options: filteredOptions,
    value,
    onClearSearch: handleClearSearch,
    onSelectAll,
    onSelectItem,
  })

  return {
    activeIndex,
    context,
    elementsRef,
    filteredOptions,
    floatingStyles,
    getFloatingItemProps,
    getFloatingProps,
    getReferenceProps,
    handleChangeSearch,
    handleClearSearch,
    handleClose,
    handleKeyDown,
    handleOpen,
    handleSelect,
    handleToggleOpen,
    handleToggleShowSelected,
    isOpen,
    refs,
    searchValue,
    setOpen,
    showSelected,
  }
}
